/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { WeatherMoonIcon16Light } from './WeatherMoonIcon16Light';
import { WeatherMoonIcon16Regular } from './WeatherMoonIcon16Regular';
import { WeatherMoonIcon16Solid } from './WeatherMoonIcon16Solid';
import { WeatherMoonIcon20Light } from './WeatherMoonIcon20Light';
import { WeatherMoonIcon20Regular } from './WeatherMoonIcon20Regular';
import { WeatherMoonIcon20Solid } from './WeatherMoonIcon20Solid';
import { WeatherMoonIcon24Regular } from './WeatherMoonIcon24Regular';
import { WeatherMoonIcon24Solid } from './WeatherMoonIcon24Solid';
import { WeatherMoonIcon32Regular } from './WeatherMoonIcon32Regular';
import { WeatherMoonIcon64Regular } from './WeatherMoonIcon64Regular';
var sizes = {
    16: {
        light: WeatherMoonIcon16Light,
        regular: WeatherMoonIcon16Regular,
        solid: WeatherMoonIcon16Solid,
    },
    20: {
        light: WeatherMoonIcon20Light,
        regular: WeatherMoonIcon20Regular,
        solid: WeatherMoonIcon20Solid,
    },
    24: {
        regular: WeatherMoonIcon24Regular,
        solid: WeatherMoonIcon24Solid,
    },
    32: {
        regular: WeatherMoonIcon32Regular,
    },
    64: {
        regular: WeatherMoonIcon64Regular,
    },
};
export var WeatherMoonIcon = forwardRef('WeatherMoonIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
